import { motion } from "framer-motion";
import { Play, Star } from "lucide-react";
import { Reveal, SectionTitle, Overline } from "@/components/Reveal";
import { imgUrl } from "@/lib/api";
import { useLiveResource } from "@/hooks/useLiveResource";

export const PlatformOfWeek = () => {
  const { data } = useLiveResource("/public/platforms", { initial: [] });
  const items = data || [];

  if (!items.length) return null;

  return (
    <section id="plataformas" className="relative py-20 md:py-28" data-testid="platforms-section">
      <div className="absolute left-1/2 top-0 -translate-x-1/2 w-[700px] h-[400px] radial-gold blur-3xl opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
        <Reveal className="text-center mb-12">
          <Overline className="inline-flex items-center gap-1.5">
            <Star className="w-3.5 h-3.5" /> Destaque
          </Overline>
          <SectionTitle className="mt-3">
            Lançamentos <span className="text-gold-gradient">do Momento</span>
          </SectionTitle>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {items.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.12}>
              <motion.div
                whileHover={{ y: -8 }}
                className="glass-gold p-4 flex flex-col group h-full"
                data-testid={`platform-card-${p.id}`}
              >
                <div className="relative rounded-2xl overflow-hidden aspect-square">
                  <div className="absolute inset-0 radial-gold blur-xl opacity-0 group-hover:opacity-60 transition-opacity duration-500" />
                  <img
                    src={imgUrl(p.image)}
                    alt={p.name}
                    loading="lazy"
                    className="relative w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="text-center mt-4 mb-1">
                  <div className="font-display font-bold text-white text-lg tracking-tight">{p.name}</div>
                </div>
                <a
                  href={p.link || "#"}
                  target={p.link ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  className={`mt-3 w-full btn-gold font-display font-bold py-3.5 rounded-full flex items-center justify-center gap-2 transition-transform hover:scale-[1.03] ${!p.link ? "opacity-70 pointer-events-none" : ""}`}
                  data-testid={`platform-play-${p.id}`}
                >
                  <Play className="w-4 h-4" fill="#120D0D" /> Jogue
                </a>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
